module.exports = __webpack_public_path__ + "img/m6fudongmu.asm.3dc2c065.jpg";